import { BaseService } from './base-service';

class DataService extends BaseService {
  /********************************
   * 线索分析
   ********************************/
  /**
   *  数据分析--线索分析--数据概览
   *
   * @author caojianbo
   * @param  {Object} data
   * @returns
   * @memberof DataService
   */
  getDataCountSummary(data) {
    return this.request({
      method: 'post',
      url: `/clueData/getDataCountSummary`,
      data
    });
  }
  /**
   *  数据分析--线索分析--数据概览-按日周月查询详细数据（图表）
   *
   * @author caojianbo
   * @param  {Object} data
   * @returns
   * @memberof DataService
   */
  getDataTableSummary(data) {
    return this.request({
      method: 'post',
      url: `/clueData/getDataTableSummary`,
      data
    });
  }
  /**
   *  数据分析--线索分析--状态分布
   *
   * @author caojianbo
   * @param  {Object} data
   * @returns
   * @memberof DataService
   */
  getDataStatusSummary(data) {
    return this.request({
      method: 'post',
      url: `/clueData/getDataStatusSummary`,
      data
    });
  }
  /**
   *  数据分析--线索分析--线索及时跟进率
   *
   * @author caojianbo
   * @param  {Object} data
   * @returns
   * @memberof DataService
   */
  getClueRateSummary(data) {
    return this.request({
      method: 'post',
      url: `/clueData/getClueRateSummary`,
      data
    });
  }
  /**
   *  数据分析--线索分析--待处理线索--柱状图数据
   *
   * @author caojianbo
   * @param  {Object} data
   * @returns
   * @memberof DataService
   */
  getTodealClueSummary(data) {
    return this.request({
      method: 'post',
      url: `/clueData/getTodealClueSummary`,
      data
    });
  }
  /**
   *  数据分析--线索分析--待处理线索--Table表格数据
   *
   * @author caojianbo
   * @param  {Object} data
   * @returns
   * @memberof DataService
   */
  getTodealClueTableSummary(data) {
    return this.request({
      method: 'post',
      url: `/clueData/getTodealClueTableSummary`,
      data
    });
  }
  /**
   *  数据分析--线索分析--待处理线索下载
   *
   * @author caojianbo
   * @param  {Object} data
   * @returns
   * @memberof DataService
   */
  downTodealClueSummary(data) {
    return this.request({
      method: 'post',
      url: `/clueData/downTodealClueSummary`,
      responseType: 'blob',
      data
    });
  }
  /**
   *  数据分析--线索分析--超2日待处理线索--柱状图数据
   *
   * @author caojianbo
   * @param  {Object} data
   * @returns
   * @memberof DataService
   */
  getTwoDayDealClueSummary(data) {
    return this.request({
      method: 'post',
      url: `/clueData/getTwoDayDealClueSummary`,
      data
    });
  }
  /**
   *  数据分析--线索分析--超2日待处理线索--Table表格数据
   *
   * @author caojianbo
   * @param  {Object} data
   * @returns
   * @memberof DataService
   */
  getTwoDayDealClueTableSummary(data) {
    return this.request({
      method: 'post',
      url: `/clueData/getTwoDayDealClueTableSummary`,
      data
    });
  }
  /**
   *  数据分析--线索分析--超2日待处理线索下载
   *
   * @author caojianbo
   * @param  {Object} data
   * @returns
   * @memberof DataService
   */
  downTwoDayDealClueSummary(data) {
    return this.request({
      method: 'post',
      url: `/clueData/downTwoDayDealClueSummary`,
      responseType: 'blob',
      data
    });
  }
  /**
   *  数据分析--线索分析--分配线索数
   *
   * @author caojianbo
   * @param  {Object} data
   * @returns
   * @memberof DataService
   */
  getAllocationClueSummary(data) {
    return this.request({
      method: 'post',
      url: `/clueData/getAllocationClueSummary`,
      data
    });
  }
  /********************************
   * 客户画像
   ********************************/
  // 客户画像--地域分布
  getCustomerArea(data) {
    return this.request({
      method: 'post',
      url: `/sysCustomer/area`,
      params: data,
      data
    });
  }
  // 客户画像--行业分布--饼图
  getCustomerCake(data) {
    return this.request({
      method: 'get',
      url: `/sysCustomer/industryCake`,
      params: data
    });
  }
  // 客户画像--行业分布--二级行业分布
  getCustomerIndustry(data) {
    return this.request({
      method: 'post',
      url: `/sysCustomer/industry`,
      data
    });
  }
  // 客户画像--规模分布
  getCustomerScale(data) {
    return this.request({
      method: 'get',
      url: `/sysCustomer/scale`,
      params: data
    });
  }
  // 客户画像--发展阶段分布
  getCustomerStage(data) {
    return this.request({
      method: 'get',
      url: `/sysCustomer/stage`,
      params: data
    });
  }
  /********************************
   * 成员榜单
   ********************************/
  /**
   *  数据分析--成员榜单--区域指标对比
   *
   * @author caojianbo
   * @param  {Object} data
   * @returns
   * @memberof DataService
   */
  getAreaComparison(data) {
    return this.request({
      method: 'post',
      url: `/analysis/memberList/area`,
      data
    });
  }
  /**
   *  数据分析--成员榜单--个人指标对比---柱状图数据
   *
   * @author caojianbo
   * @param  {Object} data
   * @returns
   * @memberof DataService
   */
  getTopComparison(data) {
    return this.request({
      method: 'post',
      url: `/analysis/memberList/top`,
      data
    });
  }
  /**
   *  数据分析--成员榜单--个人指标对比--table表格数据
   *
   * @author caojianbo
   * @param  {Object} data
   * @returns
   * @memberof DataService
   */
  getTopTableComparison(data) {
    return this.request({
      method: 'post',
      url: `/analysis/memberList/topTable`,
      data
    });
  }
  /**
   *  数据分析--成员榜单--个人指标对比---表格下载
   *
   * @author caojianbo
   * @param  {Object} data
   * @returns
   * @memberof DataService
   */
  downTopComparison(data) {
    return this.request({
      method: 'post',
      url: `/analysis/memberList/topDown`,
      responseType: 'blob',
      data
    });
  }
  /**
   *  数据分析--成员榜单--个人指标报表
   *
   * @author caojianbo
   * @param  {Object} data
   * @returns
   * @memberof DataService
   */
  getTableList(data) {
    return this.request({
      method: 'post',
      url: `/analysis/memberList/individualIndex`,
      data
    });
  }
  /**
   *  数据分析--成员榜单--个人指标报表下载
   *
   * @author caojianbo
   * @param  {Object} data
   * @returns
   * @memberof DataService
   */
  downloadExcel(data) {
    return this.request({
      method: 'post',
      url: `/analysis/memberList/downloadExcel`,
      data,
      responseType: 'blob'
    });
  }
}

export const dataService = new DataService();
